function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var HudLayer = require('../hud-layer');
var VPTemplate = require('./vp.template');
var SaitoOverlay = require('./../../../../../lib/saito/ui/saito-overlay/saito-overlay');
var VPOverlay = /*#__PURE__*/function () {
  function VPOverlay(app, mod) {
    _classCallCheck(this, VPOverlay);
    this.app = app;
    this.mod = mod;
    this.visible = false;
    this.overlay = new SaitoOverlay(app, mod);
  }
  return _createClass(VPOverlay, [{
    key: "pullHudOverOverlay",
    value: function pullHudOverOverlay() {
      HudLayer.pullHudOverOverlay.call(this);
    }
  }, {
    key: "pushHudUnderOverlay",
    value: function pushHudUnderOverlay() {
      HudLayer.pushHudUnderOverlay.call(this);
    }
  }, {
    key: "hide",
    value: function hide() {
      this.visible = false;
      try {
        document.querySelector('.acknowledge').click();
      } catch (err) {}
      this.overlay.hide();
      this.pushHudUnderOverlay();
    }
  }, {
    key: "render",
    value: function render() {
      this.visible = true;
      this.overlay.show(VPTemplate());
      this.pushHudUnderOverlay();
      var vp = this.mod.calculateVictoryPoints();
      var factions = [];
      for (var f in vp) {
        factions.push(f);
      }
      var ordered_factions = ['ottoman', 'hapsburg', 'england', 'france', 'protestant', 'papacy'];
      var html = '';
      for (var z = 0; z < ordered_factions.length; z++) {
        if (factions.includes(ordered_factions[z])) {
          html = "<div class=\"desc\">".concat(this.mod.returnFactionName(ordered_factions[z]).replace(' Empire', ''), "</div>");
          this.app.browser.addElementToSelector(html, '.factions');
          for (var i = 0; i < 9; i++) {
            if (this.mod.game.state.vp.length > i) {
              var _vp = '';
              if (this.mod.game.state.vp[i][ordered_factions[z]]) {
                _vp = this.mod.game.state.vp[i][ordered_factions[z]];
              }
              if (_vp == '' && this.mod.game.state.round > i) {
                _vp = 0;
              }
              html = "<div class=\"round round".concat(i + 1, "\">").concat(_vp, "</div>");
            } else {
              html = "<div class=\"round round".concat(i + 1, "desc\"></div>");
            }
            this.app.browser.addElementToSelector(html, '.factions');
          }
        }
      }
      this.app.browser.addElementToSelector('Victory at 25 VP', '.vp-overlay .help');
      if (this.mod.game.players.length == 2) {
        if (this.mod.game.state.round <= 4) {
          this.app.browser.addElementToSelector('Protestants should be within 8 VP of the Papacy by Round 5', '.vp-overlay .advice');
        }
        if (this.mod.game.state.round > 4) {
          this.app.browser.addElementToSelector('Instant win with 8 VP difference in points');
        }
      } else {
        this.app.browser.addElementToSelector('check your Faction Sheet for auto-win conditions...', '.vp-overlay .advice');
      }
      this.pullHudOverOverlay();
      this.attachEvents();
    }
  }, {
    key: "attachEvents",
    value: function attachEvents() {
      var _this = this;
      try {
        document.querySelector('.vp-overlay').onclick = function (e) {
          _this.hide();
        };
      } catch (err) {}
    }
  }]);
}();
module.exports = VPOverlay;